import { Danger, Info, OkCircle } from '@atom-learning/icons'
import * as React from 'react'

import { styled } from '~/styled'

import { Icon } from '../../icon/Icon'

export type AlertDialogTheme = 'info' | 'warning' | 'danger' | 'success'

const StyledIcon = styled(Icon, {
  base: ['self-start'],
  variants: {
    theme: {
      info: ['text-info'],
      warning: ['text-warning-mid'],
      danger: ['rotate-180', 'text-danger'],
      success: ['text-success']
    }
  }
})

const iconMap: Record<
  AlertDialogTheme,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {
  info: Info,
  warning: Danger,
  danger: Info,
  success: OkCircle
}

export const AlertDialogIcon = ({ theme }: { theme: AlertDialogTheme }) => (
  <StyledIcon theme={theme} is={iconMap[theme]} />
)
